import React, { Component } from "react";
//i18n
import { withNamespaces } from "react-i18next";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { Button, Container } from "reactstrap";
import Loader from "../../components/Common/Loader";
//Import form component to render
import CreateTaskForm from "../../components/Forms/CreateTaskForm";
//Import Breadcrumb
import "../Tables/datatables.scss";




class CreateUser extends Component {
  constructor(props) {
    super(props);
    let page_origin="/tasks"
    if(this.props.location.query){
      page_origin=this.props.location.query.page_origin
    }

    this.state = {
      user: JSON.parse(localStorage.getItem("authUser")),
      origin_page:page_origin
    };
  }

  goBack(event){
    event.preventDefault()
    this.props.history.push(this.state.origin_page)
  }
  render() {
    let user = this.state.user;
    if (!user) {
      return (
        <React.Fragment>
        <div className="loaderCenter">
        <Loader></Loader>
        </div>
 
      </React.Fragment>
      );
    }

    return (
      <React.Fragment>
        <div className="user-management">
          <Container fluid>
            <Button className="btn btn-primary waves-effect waves-light  usersButtons" onClick={(event)=>this.goBack(event)}>
              <i class="fas fa-arrow-left"></i> 
            </Button>
            <CreateTaskForm />
          </Container>
        </div>
      </React.Fragment>
    );
  }
}

const mapStateProps = (state) => {
  return {  };
};
export default withRouter(
  connect(mapStateProps, {})(withNamespaces()(CreateUser))
);
